export const selectFieldStyles = ['secondary', 'tertiary'] as const
export type SelectFieldStyle = (typeof selectFieldStyles)[number]

export type SelectFieldOption = {
  value: string
  label: string
}

export type SelectFieldArgs = {
  variant?: SelectFieldStyle
  label: string
  hint?: string
  value?: string
  name?: string
  id?: string
  disabled?: boolean
  required?: boolean
  placeholder?: string
  validation?: { status: 'error' | 'success' }
  optionsHtml?: string
}
